import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { set } from 'lodash';


interface filesState {
    reloadFilesData: boolean;
    fileDocumentsUrl: string | null;
    taskFileFromDocument: any;

}

const initialState: filesState = {
    reloadFilesData: false,
    fileDocumentsUrl: null,
    taskFileFromDocument: null,
}

export const filesSlice = createSlice({
    name: 'filesSlice',
    initialState,
    reducers: {
        setReloadFilesData: (state, action: PayloadAction<boolean>) => {
            state.reloadFilesData = action.payload;
        },
        setFileDocumentsUrl: (state, action: PayloadAction<string | null>) => {
            state.fileDocumentsUrl = action.payload;
        },
        setTaskFileFromDocument: (state, action: PayloadAction<any>) => {
            state.taskFileFromDocument = action.payload ? {...action.payload} : null;
        }
    },
})
export const { setReloadFilesData, setFileDocumentsUrl, setTaskFileFromDocument} = filesSlice.actions
export default filesSlice.reducer